import React from "react";
import * as S from "./styled";
import range from "lodash/range";
import CheckmarkIcon from "_c/icon/Checkmark";
import HeartIcon from "_c/icon/Heart";
import HeartFilledIcon from "_c/icon/HeartFilled";
import { LayoutGroup } from 'framer-motion';

const StepsUI = (props) => {
  return (
    <LayoutGroup id="user-reg-steps">
      <S.Wrap>
          {range(1, props.stepsAmount + 1).map((step) => {
            const isCompleted = props.completedSteps.includes(step);
            const isInactive = props.currentStep < step;
            const isActive = step === props.currentStep;
            return (
              <S.Step
                isActive={step === props.currentStep}
                isInactive={isInactive}
                isCompleted={isCompleted}
                key={step}
              >
                <span
                  css={`
                    z-index: 11;
                  `}
                >
                  {isCompleted ? <CheckmarkIcon color="white" /> : step}
                </span>
                {isActive && <S.ActiveStep layoutId="active-step-indicator" />}
              </S.Step>
            );
          })}
          <S.Step
            isActive={props.currentStep > props.stepsAmount}
            isInactive={props.completedSteps.length !== props.stepsAmount}
          >
            {props.currentStep > props.stepsAmount ? (
              <>
                <S.ActiveStep layoutId="active-step-indicator" />
                <HeartFilledIcon
                  css={`
                    z-index: 11;
                  `}
                  color="white"
                />
              </>
            ) : (
              <HeartIcon color="white" />
            )}
          </S.Step>
      </S.Wrap>
    </LayoutGroup>
  );
};

export default StepsUI;
